import { styled } from '@mui/material/styles'
import React from 'react'
import { useTranslate } from 'react-admin'
import { ReactQueryDevtools } from 'react-query/devtools'

const PREFIX = 'SectionWrapper'

const classes = {
  title: `${PREFIX}-title`,
}

const Root = styled('div')({
  [`& .${classes.title}`]: {
    fontWeight: 'bold',
    fontSize: '32px',
  },
})

type Props = {
  title?: string
  children: React.ReactNode
}

const SectionWrapper: React.FC<Props> = ({ title, children }) => {
  const translate = useTranslate()
  return (
    <Root>
      {title && <p className={classes.title}>{translate(title)}</p>}
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </Root>
  )
}

export default SectionWrapper
